let API_BASE;

if(window.location.host === 'www.sellingpower.com') {
  API_BASE = 'https://wpapi.sellingpower.com';
} else if(window.location.host === 'staging.sellingpower.com') {
  API_BASE = '//wpapi-staging.sellingpower.com';
} else {
  API_BASE = 'https://wpapi.sellingpower.com';
}

export const API = API_BASE;



// WEBPACK FOOTER //
// ./src/config/api.js